import { ApiClient } from './ApiClient';
import { Event, EventAttributes, EventCreationAttributes, EventUpdateAttributes } from '~/models/Event';

export default class EventApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/events';

  public async cloneEvent(id: number): Promise<Event> {
    const response = await this.post(`${this.BASE_URL}/clone`, { id });
    return new Event(response.data);
  }

  public async createEvent(attributes: EventCreationAttributes): Promise<Event> {
    const response = await this.post(this.BASE_URL, attributes);
    return new Event(response.data);
  }

  public async deleteEvent(id: number): Promise<number> {
    const response =  await this.delete(this.BASE_URL, { id });
    return response.data.trackerId;
  }

  public async provideEvent(id: number): Promise<Event> {
    const response = await this.get(`${this.BASE_URL}/${id}`);
    return new Event(response.data);
  }

  public async provideEvents(trackerId: number): Promise<Event[]> {
    const response = await this.get(`${this.BASE_URL}?trackerId=${trackerId}`);
    return response.data.map((attributes: EventAttributes) => new Event(attributes))
  }

  public async provideSuggestedLabels(): Promise<Array<string>> {
    const response = await this.get(`${this.BASE_URL}/saved-labels/`);
    return response.data;
  }

  public async updateEvent(attributes: EventUpdateAttributes): Promise<Event> {
    const response = await this.patch(this.BASE_URL, attributes);
    return new Event(response.data);
  }
}
